import client from "../client";

export interface GetTransactionCommissionRankingByMemberIDResponse {
  ID?: number;
  HashKey?: string;
  BetRoundID?: string;
  Amount?: number;
  Uncalculated?: boolean;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
}

export default function API(): Promise<
  GetTransactionCommissionRankingByMemberIDResponse[]
> {
  return client
    .get(`commission/get_transaction_commission_ranking_by_member_id`)
    .then((response) => response.data);
}
